import React from 'react';
// types and constants
import { AssetType, CtaFieldType } from 'libs/contentful/types';
import {
  CTA_TYPES,
  CtaEventDataType,
} from '@zola-helpers/client/dist/es/tracking/ctaEvents/ctaEvents';
// constants
import { BUSINESS_UNIT } from '@zola-helpers/client/dist/es/tracking/onboard/onboardTrackingConstants';
import { TRACKING_LOCATIONS, TRACKING_SECTIONS_EA } from 'constants/tracking';

// util
import { downloadPdf } from 'libs/client/utils/download';

// components
import StickyCta from '../StickyCta';

type DownloadPdfSectionProps = {
  inView: boolean;
  downloadFile?: AssetType;
  slug: string;
};
const DownloadPdfSection: React.FC<DownloadPdfSectionProps> = ({ inView, downloadFile, slug }) => {
  const downloadSrc = downloadFile?.src;
  const downloadFileName = downloadFile?.fileName || 'ZolaChecklist.pdf';
  const prefixedDownloadSrc = downloadSrc ? `https:${downloadSrc}` : undefined;
  if (!prefixedDownloadSrc) return null;

  const downloadButtonTitle = 'Download Printer Friendly Version (PDF)';
  const cta: CtaFieldType = {
    copy: downloadButtonTitle,
  };
  const ctaTrackingData: CtaEventDataType = {
    business_unit: BUSINESS_UNIT.WEDDINGS,
    cta_type: CTA_TYPES.BUTTON,
    group_id: 'EA_CHECKLIST_STICKY_CTA',
    cta_id: slug,
    position: 1,
    location: TRACKING_LOCATIONS.EXPERT_ADVICE,
    section: TRACKING_SECTIONS_EA.CHECKLIST_ARTICLE,
    cta: downloadButtonTitle,
  };
  const handleDownloadPdf = () => {
    downloadPdf(prefixedDownloadSrc, downloadFileName);
  };

  return (
    <StickyCta
      cta={cta}
      inView={inView}
      onClick={handleDownloadPdf}
      trackingData={ctaTrackingData}
    />
  );
};

export default DownloadPdfSection;
